import React from 'react';
import { PUBLIC_CONTACTS } from '@/config/contacts';
import './public-contacts.css';

export const PublicContacts = ({ prefix, showSales = true }) => <div className="public-contact-list" data-testid={`${prefix}-contacts`}>
    {showSales && <div><p data-testid={`${prefix}-sales-role`}>Sales · Primary contact</p><a data-testid={`${prefix}-sales-email`} href={`mailto:${PUBLIC_CONTACTS.sales}`}>{PUBLIC_CONTACTS.sales}</a></div>}
    <div><p data-testid={`${prefix}-amanda-role`}>Amanda · AI outreach & customer service associate</p><a data-testid={`${prefix}-amanda-email`} href={`mailto:${PUBLIC_CONTACTS.amanda}`}>{PUBLIC_CONTACTS.amanda}</a></div>
</div>;